export const CA_DESIGNATIONS = [
  "Chartered Financial Analyst (CFA®)",
  "Certified Financial Planner (CFP®)",
  "Chartered Investment Manager (CIM®)",
  "Chartered Alternative Investment Analyst (CAIA)",
  "Certified Investment Management Analyst (CIMA®)",
  "Personal Financial Planner (PFP®)",
  "Other professional designation"
] as const;

export const US_DESIGNATIONS = [
  "Chartered Financial Analyst (CFA®)",
  "Certified Financial Planner (CFP®)",
  "Certified Investment Management Analyst (CIMA®)",
  "Certified Private Wealth Advisor (CPWA®)",
  "Chartered Financial Consultant (ChFC®)",
  "Accredited Wealth Management Advisor (AWMA®)",
  "Other professional designation"
] as const;

export type ProfessionalDesignation =
  | (typeof CA_DESIGNATIONS)[number]
  | (typeof US_DESIGNATIONS)[number];

export const ALL_DESIGNATIONS: ReadonlyArray<ProfessionalDesignation> = Array.from(
  new Set<ProfessionalDesignation>([
    ...CA_DESIGNATIONS,
    ...US_DESIGNATIONS,
  ])
);
